import { render, staticRenderFns } from "./reserve.vue?vue&type=template&id=3b071b6c&scoped=true&"
import script from "./reserve.vue?vue&type=script&lang=js&"
export * from "./reserve.vue?vue&type=script&lang=js&"
import style0 from "./reserve.vue?vue&type=style&index=0&id=3b071b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b071b6c",
  null
  
)

export default component.exports